/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import {
  Button,
  FormControl,
  Select,
  Grid,
  InputLabel,
  TextField,
  MenuItem,
  FormHelperText,
} from "@material-ui/core";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import deLocale from "date-fns/locale/es";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import TitleCase from "react-title-case";
import { getRegionals } from "../../actions/regional-actions";
import { useStateValue } from "../../context/store";
import { styleSearch } from "./styles";
import { defaultSearchValues } from "./models";
import Utils from "../../utils/utils";

const RefundSearch = (props) => {
  const _ = require("lodash");
  const classes = styleSearch();
  const [{}, dispatch] = useStateValue();
  const [regionales, setRegionales] = useState([]);
  const [minDate, setMinDate] = useState(null);
  const [dateError, setDateError] = useState(false);
  const [dateErrorMessage, setDateErrorMessage] = useState("");
  const errorFechaInferior = "Ingrese una fecha inferior a la fecha final";
  var currentDate = new Date();

  currentDate.setMinutes(
    currentDate.getMinutes() + currentDate.getTimezoneOffset()
  );
  const [maxinitDate, setMaxinitDate] = useState(
    Utils.getFormattedDateMMddyyyy(currentDate, ".")
  );

  useEffect(() => {
    const getRegionales = async () => {
      const response = await getRegionals();
      let orderRegionales = _.sortBy(
        response.data && response.data.regionalList,
        (o) => o.name
      );
      setRegionales(orderRegionales);
    };
    getRegionales();
  }, []);

  const schema = yup.object().shape({
    initDate: yup
      .date()
      .typeError("Formato de fecha inválido")
      .when([], {
        is: (initDate) => initDate && initDate.length > 0,
        then: yup
          .date()
          .typeError("Formato de fecha inválido")
          .nullable(true)
          .required(),
        otherwise: yup
          .date()
          .typeError("Formato de fecha inválido")
          .nullable(true)
          .notRequired(),
      }),
    endDate: yup
      .date()
      .typeError("Formato de fecha inválido")
      .when([], {
        is: (endDate) => endDate && endDate.length > 0,
        then: yup
          .date()
          .typeError("Formato de fecha inválido")
          .nullable(true)
          .required(),
        otherwise: yup
          .date()
          .typeError("Formato de fecha inválido")
          .nullable(true)
          .notRequired(),
      }),
    regional: yup.string().when([], {
      is: (regional) => regional && regional.length > 0,
      then: yup.string(),
      otherwise: yup
        .string()
        .nullable(true)
        .notRequired()
        .transform((v) => (v ? v : null)),
    }),

    employeeName: yup
      .string()
      .nullable()
      .trim()
      .notRequired()
      .min(3, "Ingrese mínimo 3 caracteres")
      .max(50, "Ingrese máximo 50 caracteres")
      .matches(/^(([A-Za-zÀ-ÿ])+[ ]?)*$/g, "Ingrese un nombre válido")
      .transform((v) => (v ? v : null)),
    employeeSurname: yup
      .string()
      .nullable()
      .trim()
      .notRequired()
      .min(3, "Ingrese mínimo 3 caracteres")
      .max(50, "Ingrese máximo 50 caracteres")
      .matches(/^(([A-Za-zÀ-ÿ])+[ ]?)*$/g, "Ingrese un nombre válido")
      .transform((v) => (v ? v : null)),
  });

  const { register, handleSubmit, control, errors, getValues, setValue } =
    useForm({
      resolver: yupResolver(schema),
      defaultSearchValues,
      mode: "onChange",
      reValidateMode: "onChange",
    });

  const onChangeDate = (value) => {
    setMinDate(value);
  };

  const onSubmit = (data) => {
    if (
      data.initDate !== null ||
      data.endDate !== null ||
      data.regional !== null ||
      data.employeeName !== null ||
      data.employeeSurname !== null
    ) {
      if (data.initDate && !data.endDate) {
        data.endDate = new Date();
      } else if (data.initDate > data.endDate) {
        setDateError(true);
        setDateErrorMessage(errorFechaInferior);
        return;
      } else {
        setDateError(false);
        setDateErrorMessage("");
      }

      dispatch({
        type: "SET_FILTER_REFUND",
        filter: data,
        isFilter: true,
      });
    }
  };

  const clearForm = () => {
    setValue("employeeSurname", null);
    setValue("initDate", null);
    setValue("regional", null);
    setValue("employeeName", null);
    setValue("endDate", null);
    setDateError(false);
    setDateErrorMessage("");
    setMinDate(null);
  };

  const clearBtn = () => {
    clearForm();
    dispatch({
      type: "SET_FILTER_REFUND",
      filter: {
        employeeSurname: null,
        initDate: null,
        regional: null,
        employeeName: null,
        endDate: null,
      },
      isFilter: true,
    });
  };

  const updateMaxinitDate = (date) => {
    var currentData = getValues();
    if (!currentData.initDate) {
      setMaxinitDate(date);
    } else {
      setMaxinitDate(Utils.getFormattedDateMMddyyyy(currentDate, "."));
    }
  };

  const validateMaxinitDate = () => {
    var currentData = getValues();
    if (!currentData.endDate) {
      setMaxinitDate(Utils.getFormattedDateMMddyyyy(currentDate, "."));
    } else {
      setMaxinitDate(Utils.getFormattedDateMMddyyyy(currentData.endDate, "."));
    }
  };

  return (
    <form
      className={classes.form}
      onSubmit={handleSubmit(onSubmit)}
      autoComplete="off"
    >
      <Grid container spacing={1}>
        <Grid item xs={12} md={2} lg={2}>
          <MuiPickersUtilsProvider locale={deLocale} utils={DateFnsUtils}>
            <Controller
              as={
                <KeyboardDatePicker
                  className={classes.whiteBackGround}
                  fullWidth
                  inputVariant="outlined"
                  variant="inline"
                  format="dd/MM/yyyy"
                  dateFormat="DD/MM/YYYY"
                  label="Desde"
                  InputLabelProps={{ shrink: true }}
                  onAccept={onChangeDate}
                  onOpen={validateMaxinitDate}
                  error={
                    !!errors.hasOwnProperty("initDate") &&
                    errors["initDate"].message
                  }
                  helperText={
                    errors.hasOwnProperty("initDate") &&
                    errors["initDate"].message
                  }
                  minDate="01.01.2020"
                  maxDate={maxinitDate}
                />
              }
              control={control}
              name="initDate"
              defaultValue={null}
              placeholder="Desde"
              size="small"
            />
          </MuiPickersUtilsProvider>
          <FormHelperText style={{ color: "#f44336" }}>
            {dateError && dateErrorMessage}
          </FormHelperText>
        </Grid>
        <Grid item xs={12} md={2} lg={2}>
          <MuiPickersUtilsProvider locale={deLocale} utils={DateFnsUtils}>
            <Controller
              as={
                <KeyboardDatePicker
                  className={classes.whiteBackGround}
                  fullWidth
                  inputVariant="outlined"
                  variant="inline"
                  format="dd/MM/yyyy"
                  dateFormat="DD/MM/YYYY"
                  label="Hasta"
                  InputLabelProps={{ shrink: true }}
                  onAccept={updateMaxinitDate}
                  error={
                    !!errors.hasOwnProperty("endDate") &&
                    errors["endDate"].message
                  }
                  helperText={
                    errors.hasOwnProperty("endDate") &&
                    errors["endDate"].message
                  }
                  minDate={minDate ? minDate : "01.01.2020"}
                />
              }
              control={control}
              name="endDate"
              defaultValue={null}
              placeholder="Hasta"
              size="small"
            />
          </MuiPickersUtilsProvider>
        </Grid>

        <Grid item xs={12} md={2} lg={2}>
          <FormControl fullWidth>
            <TextField
              className={classes.whiteBackGround}
              fullWidth
              defaultValue=""
              inputRef={register}
              variant="outlined"
              type="text"
              autoComplete="off"
              error={
                !!errors.hasOwnProperty("employeeName") &&
                errors["employeeName"].message
              }
              helperText={
                errors.hasOwnProperty("employeeName") &&
                errors["employeeName"].message
              }
              label="Primer Nombre"
              name="employeeName"
              size="small"
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} md={2} lg={2}>
          <FormControl fullWidth>
            <TextField
              className={classes.whiteBackGround}
              fullWidth
              defaultValue=""
              inputRef={register}
              variant="outlined"
              type="text"
              autoComplete="off"
              error={
                !!errors.hasOwnProperty("employeeSurname") &&
                errors["employeeSurname"].message
              }
              helperText={
                errors.hasOwnProperty("employeeSurname") &&
                errors["employeeSurname"].message
              }
              label="Primer Apellido"
              name="employeeSurname"
              size="small"
            />
          </FormControl>
        </Grid>

        <Grid item xs={12} md={2} lg={2}>
          <FormControl
            variant="outlined"
            fullWidth
            size="small"
            error={
              !!errors.hasOwnProperty("regional") && errors["regional"].message
            }
          >
            <InputLabel
              htmlFor="outlined-select-regional"
              shrink={true}
              size="small"
            >
              Nombre de la regional
            </InputLabel>
            <Controller
              className={classes.whiteBackGround}
              fullWidth
              control={control}
              inputRef={register}
              label="Nombre de la regional"
              size="small"
              name="regional"
              notched={true}
              defaultValue={null}
              inputProps={{
                name: "regional",
                id: "outlined-select-regional",
              }}
              as={
                <Select>
                  <MenuItem
                    className={classes.menuItem}
                    aria-label="None"
                    value={null}
                  >
                    <em>&nbsp;</em>
                  </MenuItem>
                  {regionales.map((op) => (
                    <MenuItem
                      className={classes.menuItem}
                      key={op.id}
                      value={op.id}
                    >
                      <TitleCase string={op.name} />
                    </MenuItem>
                  ))}
                </Select>
              }
            />
            <FormHelperText>
              {errors.hasOwnProperty("regional") && errors["regional"].message}
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={2} lg={2}>
          <Button
            variant="contained"
            className={classes.buttonSearch}
            type="submit"
          >
            Buscar
          </Button>
          &nbsp;&nbsp;
          <Button
            variant="contained"
            className={classes.buttonSearch}
            type="submit"
            onClick={clearBtn}
          >
            Limpiar
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default RefundSearch;
